/** İkon renkleri — SVG filter yok (siyah halo oluşturuyordu) */

export const QUERY_ICON_BASIC = {
  core: '#d8ffff',
  glow: '#38e8ff',
  accent: '#ffffff',
};

export const QUERY_ICON_PRO = {
  core: '#fad0ff',
  glow: '#d26dff',
  accent: '#fff8ff',
};
